export interface LogoData {
  href: string;
  title: string;
  src: string;
  lang?: string[];
  university?: string[];
}

export const logos: LogoData[] = [
  {
    href: 'https://www.fhnw.ch/20jahre',
    title: 'FHNW - 20 Jahre',
    src: '/20years-logo-de.svg',
    lang: ['de'],
  },
  {
    href: 'https://www.fhnw.ch/20years',
    title: 'FHNW - 20 Years',
    src: '/20years-logo-en.svg',
    lang: ['en', 'fr'],
  },
  {
    href: 'https://www.swissuniversities.ch/',
    title: 'Swiss Universities',
    src: '/swissuniversities-logo.svg',
  },
  {
    href: 'https://eua.eu',
    title: 'European University Association',
    src: '/eua-logo.svg',
  },
  {
    href: 'https://www.aacsb.edu',
    title: 'AACSB International',
    src: '/aacsb-logo.svg',
    university: ['hsw', 'wirtschaft', 'business', 'economie'],
  },
];
